import React, { SyntheticEvent } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'dva';
import { createStructuredSelector } from 'reselect';

import {
  getAddressSearchSuggestions,
  PersonModel,
} from '../../../../selectors/addressUnmodeled';
import AddressSuggest from '../AddressSuggest/AddressSuggest';
import { SPECIAL_VALUE } from '../../../../helpers/address';

interface DispatchProps {
  onInputChange(value, method, event): void;

  setFromSuggest(value): void;
}

const mapStateToProps = createStructuredSelector({
  suggestions: getAddressSearchSuggestions,
});

function mapDispatchToProps(
  dispatch: Dispatch,
  { model }: { model: PersonModel }
): DispatchProps {
  return {
    onInputChange(address, method, event: SyntheticEvent<HTMLInputElement>) {
      const { special } = address;
      if (special && Object.values(SPECIAL_VALUE).includes(special)) {
        return;
      }
      if (['up', 'down', 'click', 'enter'].includes(method)) {
        if (typeof address === 'string') {
          dispatch({
            type: `${model}/street/change`,
            payload: { street: address },
          });
          return;
        }
        dispatch({
          type: `${model}/street/change`,
          payload: { street: address.street || '' },
        });
        return;
      }
      if (method !== 'type') {
        dispatch({
          type: `${model}/street/fetch`,
          payload: address.street || '',
        });
        return;
      }
      dispatch({ type: `${model}/street/fetch`, payload: address });
      dispatch({ type: `${model}/address/street/change`, payload: address });
    },
    setFromSuggest(payload) {
      dispatch({ type: `${model}/street/set`, payload });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressSuggest);
